<template>
  <div class="page-agenti-detail">
    <agenti-detail />
  </div>
</template>

<script>
import AgentiDetail from '@/components/ask/details/AgentiDetail.vue'


export default {
  name: 'ViewAgentiDetail',
  components: {
    AgentiDetail,
  },

  data() {
    return {
      pageName: 'AgentiDetail',
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
  
}
</script>
